<template>
  <!-- class="fit"
    style="overflow-y: auto; position: relative"
    id="_leader_page" -->
  <main @scroll="handleScroll">
    <!-- 页头 -->
    <header>
      <leader-header />
    </header>

    <!-- 组长信息 -->
    <div class="leader-info q-mx-lg q-my-md row items-center">
      <div class="text-h5 text-weight-bolder q-mr-lg non-selectable">
        {{ leaderName }}
        <span
          class="
            text-white text-bold text-caption
            bg-primary
            rounded-borders
            q-px-md q-py-xs
          "
          >组长</span
        >
      </div>
      <div
        class="
          non-selectable
          dealwith-sample
          text-subtitle2
          bg-grey-2
          q-px-md q-py-xs
          rounded-borders
        "
      >
        <p>你可以在这里处理组内样本的分配情况，</p>
        <p>作为组长你的责任重大，感谢你的认真负责的参与此次调查。</p>
      </div>
    </div>
    <div
      class="q-mx-lg system-legend"
      style="font-size: 1.2rem; font-weight: 600"
    ></div>

    <div class="main-info">
      <!-- 样本分配设置 -->
      <div class="samples-info" id="samples-distribution">
        <!-- 标题 -->
        <p class="title q-mx-lg q-my-md">
          <q-icon name="fas fa-briefcase"></q-icon>
          <span>样本信息</span>
        </p>
        <div>
          <div class="row items-center justify-between q-pr-md">
            <q-tabs
              v-model="tab"
              dense
              class="text-grey q-mx-lg q-pa-none q-mb-md"
              narrow-indicator
              active-color="primary"
              indicator-color="gray"
              inline-label
              :breakpoint="0"
              align="left"
              no-caps
            >
              <q-tab name="samples" class="rounded-borders" dense>
                <q-icon name="fas fa-city" size="12px" class="q-mr-sm" />
                <span> 样本详情 </span>
              </q-tab>
              <q-tab name="map" class="rounded-borders" dense>
                <q-icon name="fas fa-map" size="12px" class="q-mr-sm" />
                <span> 地图分布 </span>
              </q-tab>
            </q-tabs>
            <q-input
              v-model="searchKeyword"
              label="在此搜索样本名称/id"
              filled
              dense
            />
          </div>
          <q-scroll-area style="height: 36px" horizontal>
            <q-btn-toggle
              v-model="filterIndex"
              toggle-color="primary"
              class="q-mx-lg q-px-sm"
              flat
              dense
              text-color="grey-6"
              size="md"
              style="min-width: 300px"
              :options="labelOptions"
              @input="filterSample"
            ></q-btn-toggle>
          </q-scroll-area>

          <!-- <div v-if="afterFilterSamples.length==0">
            <empty/>
          </div> -->

          <q-tab-panels v-model="tab" keep-alive animated>
            <q-tab-panel name="samples">
              <sample-list
                :search-keyword="searchKeyword"
                :samplesprop="filterSearchSamples"
                :membersprop="users"
              />
            </q-tab-panel>
            <q-tab-panel name="map">
              <map-distributed
                :samplesprop="filterSearchSamples"
                style="height: 500px"
                class="q-px-md"
              />
            </q-tab-panel>
          </q-tab-panels>
        </div>
      </div>

      <div class="member-info" id="members-info">
        <p class="title q-mx-lg q-my-md">
          <q-icon name="fas fa-users"></q-icon>
          <span>组员信息</span>
        </p>
        <div>
          <member-list
            :membersprop="users"
            :samplesprop="samples"
          ></member-list>
        </div>
      </div>

      <div class="member-info" id="members-link">
        <p class="title q-mx-lg q-my-md">
          <q-icon name="fas fa-link"></q-icon>
          <span>组员关联</span>
        </p>
        <div style="overflow: auto">
          <little-group></little-group>
        </div>
      </div>
    </div>
    <q-btn
      class="q-pa-xs jump-page-btn"
      color="primary"
      size="sm"
      :icon="jumpPage.btnIcon"
      style="
        position: sticky;
        bottom: 20px;
        left: 50%;
        transform: translate(-50%);
      "
      @click="jumpBtnEvent()"
      >{{ jumpPage.btnLabel }}</q-btn
    >
  </main>
</template>

<script>
import LeaderCommonStatus from "./mixins/status.mixin";
import SampleLabelMixin from "./mixins/sample-label.mixin";
import { getUserProfile } from "../../api/endpoints/auth/getUserProfile";
import { getGroupDetailLeader } from "../../api/endpoints/group/getGroupDetailLeader";
import { getSampleGroupDetailLeader } from "../../api/endpoints/sample-group/getSampleGroupDetailLeader";
import { getAllSampleStatus } from "../../api/endpoints/sample/getAllSampleStatus";

export default {
  mixins: [LeaderCommonStatus, SampleLabelMixin],

  components: {
    LeaderHeader: () => import("./Header"),
    SampleList: () => import("./SampleList"),
    MapDistributed: () => import("./Map"),
    LineProgress: () => import("../../components/progress-bar/LineProgress"),
    LittleGroup: () => import("./LittleGroup"),
    MemberList: () => import("./MemberList"),
    Loading: () => import("../../components/Loading.vue"),
  },

  data() {
    return {
      loading: false,
      leaderName: "", // 组长信息
      groupId: "",
      samples: [], // 原始样本列表
      users: [], // 当前小组所有成员
      sampleGroupId: "", // 当前小组负责的样本组id

      allSampleLabel: [
        { description: "已分配", value: true },
        { description: "未分配", value: false },
      ],
      afterFilterSamples: [], // 筛选后当前的样本列表
      tab: "samples",
      filterIndex: "-1",
      labelOptions: [
        {
          label: "全部",
          value: "-1",
        },
      ],

      jumpPage: {
        btnLabel: "下一页",
        btnIcon: "fas fa-arrow-down",
        pageIndex: 1,
      },
      searchKeyword: "",
    };
  },

  mounted() {
    this.getUserProfileFun(); // 获取组长姓名和当前小组 id
    this.getAllSampleStatusFun();
  },

  computed: {
    isRequest() {
      return this.getCurrentGroupLeaderStatus("is_request");
    },

    filterSearchSamples() {
      const { searchKeyword, afterFilterSamples } = this;
      return (afterFilterSamples || []).filter((sample) => {
        const detail = (sample || {}).detail || {};
        return (
          (detail.name || "").indexOf(searchKeyword) > -1 ||
          (detail.sample_id || "").indexOf(searchKeyword) > -1
        );
      });
    },
  },

  watch: {
    leaderName: {
      handler(name) {
        console.log(name);
      },
    },

    groupId: {
      handler(id) {
        this.getCurrentGroupMembers(id);
      },
    },

    sampleGroupId: {
      handler(sample_group_id) {
        this.getCurrentGroupSamples(sample_group_id);
      },
    },

    sampleLabel: {
      handler(current) {
        if (current) {
          this.labelOptions = [
            {
              label: "全部",
              value: "-1",
            },
          ];
          this.sampleLabel.map((label) => {
            const options = {};
            options.label = label.description;
            options.value = label.value;
            this.labelOptions.push(options);
          });

          this.labelOptions.sort((item1, item2) => {
            return item1.value - item2.value;
          });
        }
      },
    },

    // 监听一个标记值用于页面刷新
    isRequest: {
      handler() {
        this.getCurrentGroupMembers(this.groupId);
        this.getCurrentGroupSamples(this.sampleGroupId);
      },
    },
  },

  methods: {
    /**
     * 获取组长信息
     * 组长姓名 + 当前小组 Id
     */
    async getUserProfileFun() {
      try {
        const response = await getUserProfile(true, true);
        if (response.status || response.error) {
          this.$q.notify({ type: "danger", message: "请求组长信息失败" });
        } else {
          this.leaderName = response.nickname;
          this.groupId = response.group.id;
          this.updateCurrentGroupLeaderStatus("leader_name", response.nickname); // 组长姓名
          this.updateCurrentGroupLeaderStatus(
            "current_group_id",
            response.group.id
          ); // 当前小组的 ID
        }
      } catch (err) {
        this.$q.notify({ type: "danger", message: "请求组长信息失败" });
      }
    },

    /**
     * 获取当前小组的成员
     * 成员列表 + 样本组 id
     */
    async getCurrentGroupMembers(groupId) {
      try {
        const response = await getGroupDetailLeader(groupId);
        if (response.status || response.error) {
          this.$q.notify({ type: "danger", name: "请求当前小组成员失败" });
        } else {
          this.users = response.users;
          this.sampleGroupId = response.sample_group.id;
          this.updateCurrentGroupLeaderStatus("users", response.users);
          this.updateCurrentGroupLeaderStatus(
            "sample_group_id",
            response.sample_group.id
          );
        }
      } catch (err) {
        this.$q.notify({ type: "danger", message: "获取当前小组成员失败" });
      }
    },

    /**
     * 获取当前小组的样本组
     */
    async getCurrentGroupSamples(sampleGroupId) {
      try {
        const response = await getSampleGroupDetailLeader(sampleGroupId);
        if (response.status || response.error) {
          this.$q.notify({ type: "danger", name: "请求当前小组样本组失败" });
        } else {
          this.samples = response["samples"];
          this.afterFilterSamples = response["samples"];
          this.updateCurrentGroupLeaderStatus(
            "current_group_samples",
            response["samples"]
          );
          console.log("samples", this.samples);
        }
      } catch (err) {
        this.$q.notify({ type: "danger", message: "获取当前小组样本组失败" });
      }
    },

    /**
     * 所有样本状态
     */
    async getAllSampleStatusFun() {
      try {
        const response = await getAllSampleStatus();
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          const concatLabel = this.allSampleLabel.concat(response);
          this.$set(this, "sampleLabel", concatLabel);
        }
      } catch (err) {
        this.$q.notify({ type: "danger", message: "获取样本状态列表失败" });
      }
    },

    /**
     * 样本过滤方法
     */
    filterSample() {
      let res = this.samples;
      if (this.filterIndex == "-1") {
        res = this.samples;
      } else if (
        this.sampleLabel.some((item) => {
          if (item.value === this.filterIndex) {
            return item.sample_status;
          }
        })
      ) {
        const currentStatusLabel = this.sampleLabel.filter((item) => {
          return item.value === this.filterIndex;
        });
        res = this.samples.filter((sample) => {
          return sample.sample_status == currentStatusLabel[0].sample_status;
        });
      } else if (this.filterIndex == true) {
        // 找出已经分配的
        let filterRes = this.samples.filter((sample) => {
          return sample.user != null;
        });
        res = filterRes;
      } else {
        // 找出未分配的
        let filterRes = this.samples.filter((sample) => {
          return sample.user == null;
        });
        res = filterRes;
      }
      try {
        res.sort((s1, s2) => {
          return s2.detail.name.charCodeAt() - s1.detail.name.charCodeAt();
        });
      } catch (err) {
        console.log("error sorting samples", err);
      }
      this.afterFilterSamples = res;
    },

    /**
     * 翻到下一部分
     */
    jumpBtnEvent() {
      const pageId = ["samples-distribution", "members-info", "members-link"];
      document
        .querySelector(`#${pageId[this.jumpPage.pageIndex++]}`)
        .scrollIntoView();
      if (this.jumpPage.pageIndex == 1) {
        this.jumpPage.btnLabel = "下一页";
        this.jumpPage.btnIcon = "fas fa-arrow-down";
      }

      if (this.jumpPage.pageIndex == 3) {
        this.jumpPage.pageIndex = 0;
        this.jumpPage.btnLabel = "回顶部";
        this.jumpPage.btnIcon = "fas fa-arrow-up";
      }
    },

    /**
     * 监听滚动条
     */
    handleScroll(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.offsetHeight >
          e.srcElement.scrollHeight - 100 &&
        !this.moreLoading &&
        !this.noMore
      ) {
        this.jumpPage.pageIndex = 0;
        this.jumpPage.btnLabel = "回顶部";
        this.jumpPage.btnIcon = "fas fa-arrow-up";
      } else if (e.srcElement.scrollTop == 0) {
        this.jumpPage.pageIndex = 1;
        this.jumpPage.btnLabel = "下一页";
        this.jumpPage.btnIcon = "fas fa-arrow-down";
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/quasar";

header {
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 999;
}

.leader-info {
  width: 90%;
  display: flex;
  align-content: center;
  margin-left: 5%;

  .dealwith-sample p {
    margin: 0 20px;
  }
}

.main-info {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
}

.samples-info {
  width: 33%;
  min-height: 70vh;
  min-width: 500px;
  background: #ffffff;
  border: 4px solid #124561;
  border-radius: 4px;
  margin-right: 2%;

  .title {
    font-size: 1.4rem;
    color: #124561;

    span {
      margin-left: 14px;
    }
  }

  .func-item {
    margin-left: 5%;
    font-size: 20px;
    color: #4f4f4f;

    span {
      margin-left: 13px;
      margin-right: 30px;
    }
  }
}

.member-info {
  width: 33%;
  min-height: 70vh;
  min-width: 500px;
  background: #ffffff;
  border: 4px solid #3e104e;
  border-radius: 4px;
  margin-right: 2%;

  .title {
    font-size: 1.4rem;
    color: #3e104e;

    span {
      margin-left: 14px;
    }
  }
}

.tlqn-agmli-avatar_display {
  background-color: rgba($primary, 0.2);
  color: $primary;
  font-weight: bold;
}

.jump-page-btn {
  display: none;
}

@media screen and (max-width: 800px) {
  .leader-info {
    .dealwith-sample {
      width: 100%;
      margin-top: 10px;
    }
    .dealwith-sample p {
      margin: 0;
    }
  }

  .main-info {
    flex-direction: column;
  }

  .member-info {
    width: 100%;
    margin-bottom: 30px;
  }

  .samples-info {
    width: 100%;
    margin-bottom: 30px;
  }

  .jump-page-btn {
    display: block;
  }
}
</style>
